import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MaterialModule } from '../material.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { HttpClientModule } from "@angular/common/http";

import { HotTableModule } from '@handsontable/angular';
import { registerAllModules } from 'handsontable/registry';

import { AddEvent, GridDataResult, CellClickEvent, CellCloseEvent, SaveEvent, CancelEvent,
  GridComponent, RemoveEvent
 } from '@progress/kendo-angular-grid';

 import { State, process } from '@progress/kendo-data-query';

 import { Keys } from '@progress/kendo-angular-common';

import { ProductsRoutingModule } from './products-routing.module';
import { ProductsComponent } from './products.component';
import { MaintainProductComponent } from './maintain-products/maintain-product.component';
import { ListProductComponent } from './list-products/list-products.component';
import { ReOrderProductComponent } from './reorder-products/reorder-product.component';
import { StockCountComponent } from './stock-count/stock-count.component';
import { MaintainStockComponent } from './maintain-stock/maintain-stock.component';

registerAllModules();

@NgModule({
  imports: [
    CommonModule,
    ProductsRoutingModule,
    MaterialModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatGridListModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRippleModule,
    MatDialogModule,
    //DatePipe,
    NgxSpinnerModule,
    GridModule,
    DropDownsModule,
    ButtonsModule,
    DateInputsModule,
    LayoutModule,
    PDFExportModule,
    ExcelExportModule,
    DialogsModule,
    UploadsModule,
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    HotTableModule,
  ],
  declarations: [ProductsComponent,
    MaintainProductComponent,
    ListProductComponent,
    ReOrderProductComponent,
    StockCountComponent,
    MaintainStockComponent,
  ]
})
export class ProductsModule { }
